import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 3, sm: 4 },
        px: { xs: 2, sm: 3 },
        mt: 'auto',
        backgroundColor: 'primary.main',
        color: 'white',
        textAlign: 'center',
      }}
    >
      <Typography variant="body2" sx={{ mb: 2 }}>
        © {new Date().getFullYear()} Graystone Group. All rights reserved.
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
        <IconButton
          href="https://www.linkedin.com/company/graystonegroupstaffing"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ 
            color: 'white',
            '&:hover': {
              color: 'rgba(255, 255, 255, 0.8)',
            }
          }}
        >
          <LinkedInIcon fontSize="medium" />
        </IconButton>
        <IconButton
          href="https://www.instagram.com/graystonegroup_/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ 
            color: 'white',
            '&:hover': {
              color: 'rgba(255, 255, 255, 0.8)',
            }
          }}
        >
          <InstagramIcon fontSize="medium" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Footer; 